<div class="dropdown" [style.minWidth.px]="minWidth">
  <div (click)="toggle($event)">
    <span class="dropdown-label" *ngIf="selectedName">
      {{ selectedName }}
    </span>
    <span class="dropdown-label" *ngIf="!selectedName">
      {{ placeholder }}
    </span>
    <i class="fa fa-caret-down" aria-hidden="true"></i>
  </div>
  <div
    class="dropdown-backdrop"
    *ngIf="panelOpen"
    (click)="toggle($event)"
  ></div>
  <ul
    class="dropdown-menu o-list o-dropdown__items"
    aria-labelledby="locationDropdown"
    *ngIf="panelOpen"
  >
    <li class="o-dropdown__item" *ngFor="let item of getItems(); let i = index">
      <a
        href="#"
        #listItem
        class="dropdown-menu-item with-icon"
        (keydown)="handleKeyboardEvent($event.keyCode, $event)"
        (click)="selectAndClose(item, $event)"
        [class.active]="isActive(i)"
        (mouseenter)="selectActive(i)"
      >
        {{ item.name }}
      </a>
    </li>
  </ul>
</div>
